import BaseController from './base_controller'

export default class extends BaseController {
  static targets = ['select', 'year']

  sync() {
    this.yearTargets.forEach(input => { input.value = this.selectTarget.value })
    this.dispatch('yearChanged')
    addFormWarningTooltip($(this.selectTarget), 'You have made changes to the IMO reference. Please press calculate in order to see amended results.')
  }
}
